<template>
  <div>
    <div class="is-flex is-flex-direction-column is-align-items-center">
      <div class="m-4">
        <LinkEntity :payload="alert.resources.position" :additional_data="{ resource_type: 'Position' }" />
      </div>
      <div class="m-4">
        <LinkEntity :payload="alert.resources.company" />
      </div>
      <div class="m-4">
        <QuestionEditor :payload="{ question: urgency, resource_type: 'Position', resource_id: this.alert.resources.position.id }" />
      </div>
    </div>
    <div class="modal_footer">
      <a @click="done" class="button is-info">Done</a>
    </div>
  </div>
</template>

<script>
import LinkEntity from '@/components/LinkEntity'
import QuestionEditor from '@/components/QuestionEditor.vue'

export default {
  name: 'FeedModalReviewPosition',
  components: {
    LinkEntity,
    QuestionEditor
  },
  props: {
    payload: {
      type: Object,
      default: () => ({})
    },
    onSubmit: {
      type: Function,
      default: () => {}
    }
  },
  data () {
    return {
      urgency: null,
      alert: null
    }
  },
  async created () {
    this.alert = await this.$network_utils.getAlert(this.payload.data.resource_id)
    this.$network_utils.getResourceQuestions({
      current_type: 'Position',
      current_resource_id: this.alert.resources.position.id,
      designators: 'urgency'
    }).then(response => {
      this.urgency = response[0]
    })
  },
  methods: {
    done () {
      this.onSubmit(this.payload.modal_id)
    }
  }
}
</script>
